import { createSlice } from "@reduxjs/toolkit";
const dateTimeSlice = createSlice({
  name: "dateTimeSlice",
  initialState: {
    summary: {
      date: {
        startDate: "",
        endDate: "",
        filterName: "Last 30 days",
      },
    },
    manageFarmer: {
      date: {
        startDate: "",
        endDate: "",
        filterName: "Last 30 days",
      },
    },
    manageSurveyor: {
      date: {
        startDate: "",
        endDate: "",
        filterName: "Last 30 days",
      },
    },
  },
  reducers: {
    updateDateTimeStr: (state, action) => {
      switch (action.payload.screenName) {
        case "summary":
          state.summary.date = {
            startDate: action.payload.startDate,
            endDate: action.payload.endDate,
            filterName: action.payload.filterName,
          };
          break;
        case "manageFarmer":
          state.manageFarmer.date = {
            startDate: action.payload.startDate,
            endDate: action.payload.endDate,
            filterName: action.payload.filterName,
          };
          break;
        case "manageSurveyor":
          state.manageSurveyor.date = {
            startDate: action.payload.startDate,
            endDate: action.payload.endDate,
            filterName: action.payload.filterName,
          };
          break;
        default:
          throw "Invalid action";
      }
    },
  },
});

export const { updateDateTimeStr } = dateTimeSlice.actions;
export default dateTimeSlice.reducer;
